<app-page-header
  title="Home"
  active_item="CriptoAtivos"
  titleLink="/reports"
></app-page-header>
<div class="loading-crypto" *ngIf="!isLoaded">
  <div class="dimmer active">
    <div class="lds-ring">
      <div></div>
    </div>
  </div>
</div>
<h5>{{ "common.cryptoWithdrawals" | translate }}</h5>
<form [formGroup]="crypto">
  <div class="row">
    <div class="col-12">
      <div class="card rounded-10 shadow" *ngIf="!isInsert">
        <div class="card-header">
          <div class="card-title mb-0">
            {{ "common.withdrawals" | translate }}
          </div>
          <button
            type="button"
            class="our-button btn btn-pill btn-primary float-end"
            (click)="openWithdraw()"
          >
            <i class="fe fe-arrow-up-right"></i
            >{{ "common.withdraw" | translate }}
          </button>
        </div>
        <div class="card-body">
          <div class="scrollable-layout">
            <div class="table-responsive our-table">
              <table class="table table-striped text-nowrap mb-0">
                <thead class="border-top">
                  <tr>
                    <th scope="col" class="text-capitalize">
                      {{ "common.date" | translate }}
                    </th>
                    <th scope="col" class="text-capitalize">
                      {{ "common.status" | translate }}
                    </th>
                    <th scope="col" class="text-capitalize">
                      {{ "common.currency" | translate }}
                    </th>
                    <th scope="col" class="text-capitalize">
                      {{ "common.wallet" | translate }}
                    </th>
                    <th scope="col" class="text-capitalize">
                      {{ "common.cryptoValue" | translate }}
                    </th>
                    <th scope="col" class="text-capitalize">
                      {{ "common.txId" | translate }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="border-bottom" *ngFor="let crypto of cryptos">
                    <td>
                      <span>{{
                        crypto.data | date : "dd/MM/yyyy HH:mm:ss" : "GMT"
                      }}</span>
                    </td>
                    <td>
                      <span
                        class="status-badge"
                        [ngClass]="formatStatusClass(crypto.status)"
                      >
                        <ng-container
                          *ngIf="
                            (crypto.status || '').toUpperCase() === 'PENDENTE';
                            else normalStatus
                          "
                        >
                          {{ "common.inProcess" | translate }}
                        </ng-container>

                        <ng-template #normalStatus>
                          {{ crypto.status | label : "status" }}
                        </ng-template>
                      </span>
                    </td>
                    <td>
                      <span>{{ crypto.symbol }}</span>
                    </td>
                    <td>
                      <span>{{ crypto.wallet }}</span>
                    </td>
                    <td>
                      <span
                        >$
                        {{
                          crypto.value
                            | mask
                              : "separator.4"
                              : { thousandSeparator: ".", decimalMarker: "," }
                        }}
                      </span>
                    </td>
                    <td
                      class="txid"
                      (click)="crypto.txId && copyTxid(crypto.txId)"
                    >
                      <div class="txid-container" *ngIf="crypto.txId">
                        <i class="fe fe-copy" style="margin-right: 8px"></i>
                        <span class="truncate" [attr.title]="crypto.txId">{{
                          crypto.txId
                        }}</span>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="cryptos.length == 0">
                    <td colspan="6">{{ "common.noData" | translate }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-flex justify-content-between p-2">
              <ngb-pagination
                [collectionSize]="total"
                [maxSize]="5"
                [rotate]="true"
                [(page)]="page"
                [pageSize]="pageSize"
                (pageChange)="pageChange()"
              >
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="card rounded-10 shadow" *ngIf="isInsert">
        <div class="card-header">
          <div class="card-title mb-0">
            {{ "common.insertWallet" | translate }}
          </div>
        </div>
        <div class="card-body">
          <div class="alert alert-dark text-center" role="alert">
            <b
              >{{ "common.availableBalance" | translate }}:
              {{ saldoDisponivel | formatCurrency }}</b
            >
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="slSymbols" class="form-label"
                  >{{ "common.currency" | translate }}
                  <span class="text-danger">*</span></label
                >
                <ng-select
                  id="slSymbols"
                  [searchable]="false"
                  [clearable]="false"
                  [items]="symbols"
                  bindValue="id"
                  bindLabel="description"
                  [formControl]="crypto.controls.symbol"
                  (change)="loadWallets()"
                />
                <div class="invalid-feedback">
                  {{ "common.currencyRequiredMessage" | translate }}!
                </div>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="slCarteira" class="form-label"
                  >{{ "common.wallet" | translate }}
                  <span class="text-danger">*</span></label
                >
                <ng-select
                  id="slCarteira"
                  [searchable]="false"
                  [clearable]="false"
                  [items]="wallets"
                  bindValue="id"
                  [formControl]="crypto.controls.wallet"
                >
                  <ng-template ng-option-tmp let-item="item">
                    {{ item.description }} {{ item.hash }}
                  </ng-template>

                  <ng-template ng-label-tmp let-item="item">
                    {{ item.description }} {{ item.hash }}
                  </ng-template>
                </ng-select>
                <div class="invalid-feedback">
                  {{ "common.walletRequiredMessage" | translate }}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtValue" class="form-label"
                  >{{ "common.value" | translate }}
                  <span class="text-danger">*</span></label
                >
                <input
                  placeholder="{{ 0 | formatCurrency }}"
                  currencyMask
                  [options]="{ prefix: ('' | currencySymbol) + ' ' }"
                  [formControl]="crypto.controls.value"
                  class="form-control"
                  type="text"
                  id="txtValue"
                  [ngClass]="{
                    'is-invalid state-invalid':
                      crypto.controls.value.invalid && isSubmitted
                  }"
                  (focusout)="valorChanged()"
                />
                <div class="invalid-feedback">
                  {{ "common.valueRequired" | translate }}
                </div>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtTotalValue" class="form-label"
                  >{{ "common.cryptoAmount" | translate }}
                  <span class="text-danger">*</span></label
                >
                <input
                  [formControl]="crypto.controls.cryptoValue"
                  mask="separator.4"
                  decimalMarker="."
                  thousandSeparator=","
                  class="form-control"
                  type="text"
                  id="txtTotalValue"
                  [readonly]="true"
                />
              </div>
            </div>
          </div>
          <button
            type="button"
            class="btn btn-pill btn-primary float-start"
            (click)="return()"
          >
            <i class="fe fe-arrow-left"></i>{{ "common.back" | translate }}
          </button>
          <button
            type="button"
            class="btn btn-pill btn-primary float-end"
            (click)="withdraw()"
          >
            <i class="fe fe-plus"></i>{{ "common.withdrawButton" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
<ng-template #requestTOTPCode let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ "common.informAuthToken" | translate }}</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click'); isLoaded = true"
    ></button>
  </div>
  <div class="modal-body">
    <div class="form-group mt-2">
      <p *ngIf="errorMessage.length > 0" class="text-danger">
        {{ errorMessage }}
      </p>
    </div>
    <div class="form-group mb-3">
      <input
        type="text"
        class="form-control"
        id="authToken"
        placeholder="Token"
        [(ngModel)]="validationCode"
        (keyup.enter)="validateTotp()"
      />
      <button
        (click)="pasteTotpCode()"
        class="btn btn-primary btn-block btn-colar h-30 w-30 mx-auto mt-2 mb-1"
      >
        {{ "login.totp.pasteButton" | translate }}
      </button>
    </div>
  </div>
  <div class="modal-footer text-center">
    <button
      type="submit"
      class="btn btn-lg btn-primary btn-pill mx-auto d-block"
      (click)="validateTotp()"
      [disabled]="validatingTotp"
    >
      {{ "common.validateButton" | translate }}
    </button>
  </div>
</ng-template>
